<div class="loading" *ngIf="dataLoading">
  <mat-spinner></mat-spinner>
</div>

<mat-grid-list cols="4" rowHeight="300px" gutterSize="20px" *ngIf="!dataLoading">

    <mat-grid-tile *ngFor="let product of products">

        <app-slide class="product-grid-tile" class="product-grid-tile" [item]=product [imageSrc]=product.image_file>

        </app-slide>
    </mat-grid-tile>
</mat-grid-list>


// WEBPACK FOOTER //
// ./src/app/search-results/search-results.component.html